import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FrontendServices } from '@ibexfusion/core-utils';
import { Models } from '@ibexfusion/models';
import { MyExternalTokensService } from '@services/my-external-tokens/my-external-tokens.service';
import { PackageService } from '@services/packages/package.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { DashboardDataDialogComponent } from '../dashboard-data-dialog/dashboard-data-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'static-playouts',
    templateUrl: './static-playouts.component.html',
    styleUrls: ['./static-playouts.component.scss'],
    providers: [MyExternalTokensService],
    standalone: false
})
export class StaticPlayoutsComponent implements OnInit {

  @Input() dashboardData: any
  @HostBinding('class.hidden') hidden = false;
  tokens: Models.MyExternalToken[] = [];
  contentOnly = true;
  hasIbexinfo: boolean;

  constructor(
    private tokenService: MyExternalTokensService, private packageService: PackageService, private ms: MessengerService, private dialog: MatDialog, private router: Router
  ) {
  }

  async ngOnInit() {
    const packages = (await this.packageService.find(0, 100, { customerId: this.ms.$activeOrganisation.getValue().organisationCustomerId, underConstruction: { $ne: true } })).data;
    if (packages?.length) {
      for (const pak of packages) {
        this.hasIbexinfo = pak?.devices?.length ? pak.devices.includes('ibexinfo') : pak?.ibexInfo?.enabled
      }
    }
    this.contentOnly = !this.dashboardData.find(el => el.path === 'navigation')
    if (this.contentOnly) {
      this.dashboardData.forEach(el => {
        if (el.subRoutes?.find(subEl => subEl.path === 'navigation')) {
          this.contentOnly = false;
        }
      });
    }
    this.tokens = (await this.tokenService.find(0, 20)).data;
    this.hidden = !this.tokens?.length && !this.hasIbexinfo;
  }

  login(token: Models.ExternalToken) {
    this.post(token.parameters, token.endpoint, token.type, token.target);
  }

  private post(parameters: Models.LoginParameter[], url, type, target) {
    const mapForm = document.createElement('form');
    mapForm.target = '_' + target;
    mapForm.method = type;
    mapForm.action = url;
    for (const param of parameters) {
      if (!param.name || !param.value) {
        continue;
      }
      const mapInput = document.createElement('input');
      mapInput.type = 'hidden';
      mapInput.name = param.name;
      mapInput.setAttribute('value', param.encrypted ? FrontendServices.EncryptionService.encryptAesString(param.value + '|' + Date.now()).toString() : param.value);
      mapForm.appendChild(mapInput);
    }
    document.body.appendChild(mapForm);
    mapForm.submit();
    document.body.removeChild(mapForm);
  }

  openConfigInfo(type) {
    const _filterDashboard = this.dashboardData.filter(el => el && el.path !== 'dashboard' && !!el.data.isIbexinfo);
    if (_filterDashboard.length >= 2) {
      const dialogRef = this.dialog.open(DashboardDataDialogComponent, { data: { type: type, menuData: _filterDashboard }, width: '400px', panelClass: 'dashboard-data-modal' });
      dialogRef.afterClosed().toPromise().then(result => {});
    } else if (_filterDashboard.length === 1) {
      const route = _filterDashboard[0].subRoutes.find(sr => type === 'content' ? sr.path === 'dynamic-content' : sr.path === 'navigation');
      const title = _filterDashboard[0].data.title;
      this.navigate(route, title);
    }
  }

  navigate(route, title) {
    const commands = [{ outlets: { primary: [route?.path], org: this.ms.getOrganisation().name } }];
    if (route.data.packageId) {
      commands[0].outlets.primary.push(route.data.packageId);
    }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(commands));
    route.mainDataTitle = title;
    this.ms.setPackageConfiguration(route.metaConfig);
    this.ms.setRouteFromDashboard(route);
  }
}
